import * as types from 'store/modules/hrms14x/mutation-types'
import { constLabels } from 'assets/js/constLabels.js'
import hrms14xLabels from 'assets/labels/hrms14x'
import hrms14x from 'api/hrms14x'
import swal from 'sweetalert'
import { hrms14xColumns } from 'assets/columns/hrms14x'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    popupStatusEditDisp: false,
    labels: hrms14xLabels,
    columns: hrms14xColumns(),
    searchParamsIndex: {},
    index: {
      total: 0,
      rows: []
    },
    popupStatus: {
      total: 0,
      rows: []
    },
    popupStatusEdit: {
      total: 0,
      rows: []
    },
    popupRouteNo: {
      total: 0,
      rows: []
    },
    response: {
      status: '',
      message: ''
    },
    indexSelected: [],
    popupSelected: []
  },
  getters: {
    [types.GET_HRMS14X_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS14X_POPUP_STATUS_EDIT_DISP] (state) {
      return state.popupStatusEditDisp
    },
    [types.GET_HRMS14X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS14X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS14X_SEARCH_PARAMS_INDEX] (state) {
      return state.searchParamsIndex
    },
    [types.GET_HRMS14X_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS14X_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS14X_POPUP_SELECTED] (state) {
      return state.popupSelected
    },
    [types.GET_HRMS14X_STATUS_POPUP] (state) {
      return state.popupStatus
    },
    [types.GET_HRMS14X_STATUS_EDIT_POPUP] (state) {
      return state.popupStatusEdit
    },
    [types.GET_HRMS14X_ROUTE_NO_POPUP] (state) {
      return state.popupRouteNo
    }
  },
  mutations: {
    [types.SET_HRMS14X_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS14X_POPUP_STATUS_EDIT_DISP] (state, popupStatusEditDisp) {
      state.popupStatusEditDisp = popupStatusEditDisp
    },
    [types.SET_HRMS14X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].popupStatusColumns = configLabel.replaceLabelToColumns(state.columns[keyLang].popupStatusColumns, labels[keyLang])
        state.columns[keyLang].popupStatusEditColumns = configLabel.replaceLabelToColumns(state.columns[keyLang].popupStatusEditColumns, labels[keyLang])
        state.columns[keyLang].popupRouteNoColumns = configLabel.replaceLabelToColumns(state.columns[keyLang].popupRouteNoColumns, labels[keyLang])
      }
    },
    [types.SET_HRMS14X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS14X_SEARCH_PARAMS_INDEX] (state, searchParamsIndex) {
      state.searchParamsIndex = searchParamsIndex
    },
    [types.SET_HRMS14X_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS14X_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS14X_POPUP_SELECTED] (state, popupSelected) {
      state.popupSelected = popupSelected
    },
    [types.SET_HRMS14X_STATUS_POPUP] (state, popupStatus) {
      state.popupStatus = popupStatus
    },
    [types.SET_HRMS14X_STATUS_EDIT_POPUP] (state, { popupStatusEdit, staappr }) {
      for (let popupStatusEditRow of popupStatusEdit.rows) {
        popupStatusEditRow.staappr = staappr
      }
      state.popupStatusEdit = popupStatusEdit
    },
    [types.SET_HRMS14X_ROUTE_NO_POPUP] (state, popupRouteNo) {
      state.popupRouteNo = popupRouteNo
    }
  },
  actions: {
    [types.TOGGLE_HRMS14X_PAGE] ({ commit }, page) {
      let indexDisp = false
      let popupStatusEditDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'status':
          popupStatusEditDisp = true
          break
      }
      commit(types.SET_HRMS14X_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS14X_POPUP_STATUS_EDIT_DISP, popupStatusEditDisp)
    },
    [types.RECEIVED_HRMS14X_COLUMNS_LABELS] ({ commit }) {
      hrms14x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS14X_COLUMNS, data.labels)
          commit(types.SET_HRMS14X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS14X_INDEX] ({ commit }, searchParams) {
      hrms14x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS14X_INDEX, data)
          commit(types.SET_HRMS14X_SEARCH_PARAMS_INDEX, searchParams)
        })
        .catch((response) => {
          const data = response.response.data
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS14X_INDEX, objData)
          swal({
            title: '', text: data.response, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS14X_STATUS_POPUP] ({ commit }, popupParams) {
      hrms14x.getPopupStatus(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS14X_STATUS_POPUP, data)
          commit(types.SET_HRMS14X_POPUP_STATUS_EDIT_DISP, false)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS14X_STATUS_EDIT_POPUP] ({ commit }, popupParams) {
      hrms14x.getPopupStatusEdit(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS14X_STATUS_EDIT_POPUP, { popupStatusEdit: data, staappr: popupParams.staappr })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS14X_ROUTE_NO_POPUP] ({ commit }, popupParams) {
      hrms14x.getPopupRouteNo(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS14X_ROUTE_NO_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS14X_STATUS_EDIT_SAVE] ({ commit, dispatch }, { dataRowsHasFlg, popupParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms14x.postPopupStatusEditSave({ dataRowsHasFlg })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS14X_STATUS_POPUP, popupParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms14x/index.js